<template>
    <div class="ring-1 ring-gray-75 rounded-t-md mb-8 overflow-hidden">
        <div class="h-10 py-3 px-2.5 rounded-t-md md:px-5 shine" />
        <div class="md:bg-white">
            <ul class="divide-y divide-dashed h4 ">
                <li class="px-2.5 pt-2.5 md:px-5 flex">
                    <SkeletonSentence class="w-1/4 rounded-lg mr-4" />
                    <SkeletonSentence class="w-1/3 rounded-lg" />
                </li>
                <li class="px-2.5 pt-2.5 md:px-5 flex">
                    <SkeletonSentence class="w-1/4 rounded-lg mr-4" />
                    <SkeletonSentence class="w-3/5 rounded-lg" />
                </li>
                <li class="px-2.5 pt-2.5 md:px-5 flex">
                    <SkeletonSentence class="w-1/4 rounded-lg mr-4" />
                    <SkeletonSentence class="w-1/2 rounded-lg" />
                </li>
                <li class="px-2.5 pt-2.5 md:px-5 flex">
                    <SkeletonSentence class="w-1/4 rounded-lg mr-4" />
                    <SkeletonSentence class="w-1/4 rounded-lg" />
                </li>
                <li class="px-2.5 pt-2.5 md:px-5 flex">
                    <SkeletonSentence class="w-1/4 rounded-lg mr-4" />
                    <SkeletonSentence class="w-1/3 rounded-lg" />
                </li>

                <li class="px-2.5 pt-2.5 md:px-5 flex justify-end">
                    <SkeletonSentence class="w-1/3 rounded-lg" />
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import SkeletonSentence from '@/components/skeletons/SkeletonSentence.vue';

export default {
    components: {
        SkeletonSentence
    },
};
</script>
